import { Colours } from "../../utils/colours";

interface BorderColourProps {
	data?: Queries.ParagraphSectionsDataFragment;
}
export const getBorderColour = ({ data }: BorderColourProps) => {
	if (!data) return Colours.WHITE;
	const { __typename, ...props } = data;
	switch (__typename) {
		case "paragraph__section": {
			const componentName = (props as Queries.ParagraphSectionDataFragment)
				.relationships.field_section.relationships.field_component_type.name;
			if (
				[
					"QuickLinks",
					"QuickLinksInset",
					"QuickLinksInsetWithSearch",
					"Volunteering-Role-Lookup",
					"OurStoriesFilteredList",
					"DogsTrustBehaviourHelplineForm",
					"DogsTrustContactForm",
					"BreedSearchListAndFilters",
					"BreedSearch",
				].includes(componentName)
			)
				return Colours.SANDY_FUR;

			return Colours.WHITE;
		}
		case "paragraph__checklist":
			if (data.field_list_type === "bulletlist") return Colours.OATMEAL;
			return Colours.SANDY_FUR;
		case "paragraph__aligned_image_and_text":
			return Colours.SANDY_FUR;
		default:
			return Colours.WHITE;
	}
};
